import { BCMSDate, useStateManager, Branding } from "@bcm-dev/bcms-vite";
import React, { useEffect, useRef } from "react";

import { SVGAsset } from "res";
import ChatItem from "../../classes/ChatItem";
import { ReceivedMessageWidget } from "../ChatMessageWidget";
import { UITextInput } from "components/ui";
import ChatFeaturePopup from "../ChatFeaturesPopup";
import ChatEndSessionPopup from "../ChatEndSessionPopup";
import ChatTranslationPopup from "../ChatTranslationPopup";
import "./mobile.css";
import "./styles.css";

export default function ChatWidget(props) {
    const { data, ui, onMessageAdd, onMessageInput, onUIClick } = useStateManager();
    const textArea = useRef();
    const onChange = evt => onMessageInput(textArea.current.value);

    const sendBtn = evt => {
        if(!ui.sessionHasEnded) {
            const message = data.messageInput;
            const date = BCMSDate.init();
            const recieved = "Please hold, someone will be with your shortly. You are number 1 in line.";

            const userMessage = ChatItem.init(message, "sent", date, 0);
            const responseMessage = ChatItem.init(recieved, "received", date, 2);

            onMessageAdd(userMessage, true);
            setTimeout(() => onMessageAdd(responseMessage), 2000);
        }
    }

    return (
        <div className="chat-widget flex-container flex-vertical">
          <div className="set-height chat-widget-header flex-container flex-horizontal align-center">
            <div className="flex-width">
              <h2>Chat</h2>
            </div>
            <div className={`set-width flex-container flex-horizontal justify-end clickable ${ ui.sessionHasEnded ?  "disable-icon-button " : "" }`} onClick={ onUIClick("showEndSessionPopup", true) }  >
              <SVGAsset id="CloseX" className="icon close-icon" />             
            </div>
          </div>
          <div className="flex-height chat-content-container flex-container flex-vertical hide-scrollbar ">
            { ui.showInitialMessage && <ReceivedMessageWidget /> }
      
            { data.messages.map((message, index) => React.cloneElement(message.component, { key: index })) }
        
          </div>
          <div className="flex-width chat-textarea-container flex-container flex-horizontal align-center">
          <Branding id="additional_chat_functionality_abi22" value="true" default="true">
            <div className={`set-width feature-button-container clickable ${ui.sessionHasEnded ? "disable-icon-button " : ""}`} onClick={onUIClick("showFeaturePopup", true)} >
              <SVGAsset id="PlusIcon" className="plus-icon" data-point="Chat_Widget_Plus_Icon" />
            </div>
          </Branding>
            <UITextInput className="chat-textfield" placeholder="Chat Message ..." value={ data.messageInput }  onChange={ onMessageInput } data-point="Chat_Enter_Message" disabled={ui.sessionHasEnded} />
            <div className={ `send-button flex-container flex-horizontal align-center clickable ${ ui.sessionHasEnded ?   "disable" : "" }` } onClick={ sendBtn } data-point="Chat_Send_Message">
              <SVGAsset id="SendArrowIcon" />
            </div>
          </div>
          <ChatFeaturePopup />
          <ChatEndSessionPopup />
          <ChatTranslationPopup />
        </div>
      );
}

